import { Injectable } from '@angular/core';
import * as Constants from "../utils/Constants";
import { BehaviorSubject } from 'rxjs';

export type ConfigStatus = 'NOT_SAVED' | 'UNSAVED_CHANGES' | 'SAVED';

const CONFIG_STATUS_KEY = 'iCaluwin-ConfigStatus';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private configStatusSubject = new BehaviorSubject<ConfigStatus>(this.getConfigStatus());
  configStatus$ = this.configStatusSubject.asObservable();
  static getProject() {
    throw new Error('Method not implemented.');
  }

  constructor() {
    this.init();
  }

  async init() {
  }

  setConfigStatus(status: ConfigStatus) {
    localStorage.setItem(CONFIG_STATUS_KEY, status);
    this.configStatusSubject.next(status);
  }

  getConfigStatus(): ConfigStatus {
    return (localStorage.getItem(CONFIG_STATUS_KEY) as ConfigStatus) || 'NOT_SAVED';
  }

  public set(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  public get(key: string) {
    return localStorage.getItem(key);
  }
  public getProject() {
    return localStorage.getItem('iCaluwin-LastProject');
  }
  getMasterData(): any | null {
    const data = localStorage.getItem(Constants.STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  }
  getSpacers(): any[] {
    const masterData = this.getMasterData();
    return masterData?.spacers ?? [];
  }

  saveCurrentProject() {

    const current = {
      "language": "",
      "projectName": this.getDefaultProjectName(),
      "projecttype": "cal",
      "uw": 6,
      "windowframe": this.getDefaultFrame(),
      "windowglas": this.GetDefaultGlas(),
      "muntin": Constants.data_muntin,
      "spacer": this.getSpacerById('4'),
      "spacerExpert": null,
      "windowtype": Constants.data_windows[0].id,
      "dimensions": {
        "a": 1.23,
        "b": 1.48,
        "c": 0,
      },
      // "area": this.calcArea(), 
      // "glasArea": this.calcGlassArea(),
      // "frameArea": this.calcFrameArea()
    };
    const json = JSON.stringify(current);

    try {
      localStorage.setItem('iCaluwin-LastProject', json);
      this.setConfigStatus('NOT_SAVED');
    } catch (e) {
      console.error('Error saving current project:', e);
    }

  }

  updateProject(updates: { [key: string]: any }): boolean {
    this.setConfigStatus('UNSAVED_CHANGES');
    return this.updateStorage('iCaluwin-LastProject', updates);
  }

  //compared window-2
  public getComparedProject() {
    return localStorage.getItem('iCaluwin-LastProject-1');
  }

  saveComparedProject(projectData?: any) {
    const comparedProject = projectData || {
      "language": "",
      "projectName": `${this.getDefaultProjectName()}-compared`,
      "projecttype": "cal",
      "uw": 4,
      "windowframe": this.getWindow2DefaultFrame(),
      "windowglas": this.getWindow2DefaultGlass(),
      "muntin": Constants.data_muntin,
      "spacer": this.getSpacerById('4'),
      "spacerExpert": null,
      "windowtype": Constants.data_windows[0].id,
      "dimensions": {
        "a": 1.23,
        "b": 1.48,
        "c": 0,
      },
    };

    try {
      localStorage.setItem('iCaluwin-LastProject-1', JSON.stringify(comparedProject));
      console.log('Compared project saved');
      return true;
    } catch (e) {
      console.error('Error saving compared project:', e);
      return false;
    }
  }

  updateComparedProject(updates: { [key: string]: any }): boolean {
    // Initialize if doesn't exist
    if (!this.getComparedProject()) {
      this.saveComparedProject();
    }
    this.setConfigStatus('UNSAVED_CHANGES');
    return this.updateStorage('iCaluwin-LastProject-1', updates);
  }

  private updateStorage(storageKey: string, updates: { [key: string]: any }): boolean {
    try {
      const storedProject = localStorage.getItem(storageKey);
      let currentProject: any = {};

      if (storedProject) {
        try {
          currentProject = JSON.parse(storedProject);
        } catch (parseError) {
          console.error(`Error parsing ${storageKey}, creating new:`, parseError);
          currentProject = {};
        }
      }

      if (typeof currentProject !== 'object' || currentProject === null) {
        currentProject = {};
      }

      // Batch update
      Object.keys(updates).forEach(key => {
        currentProject[key] = updates[key];
      });

      localStorage.setItem(storageKey, JSON.stringify(currentProject));
      console.log(`${storageKey} updated:`, updates);

      return true;
    } catch (error) {
      console.error(`Error updating ${storageKey}:`, error);
      return false;
    }
  }


  getDefaultProjectName(): string {
    const date = new Date();
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `project${year}-${month}-${day}`;
  }

  getById<T extends { id: string }>(caluwinData: T[], id: string): T | null {
    let result: T | null = null;

    for (const value of caluwinData) {
      if (value.id == id) {
        result = value;
        break;
      }
    }
    return result;
  }

  getSpacerById(id: string) {
    const spacers = this.getSpacers();
    console.log(spacers, id)
    var result = this.getById(spacers, id);
    return result;
  };

  GetDefaultGlas() {
    return {
      "id": "25",
      "name": "CLIMATOP ECLAZ",
      "type": "Energiegewinnung",
      "structure": "4/4/4",
      "interiorGlassThickness": 4,
      "exteriorGlassThickness": 4,
      "cavity": "14a/14a",
      "thickness": 40,
      "ug": 0.6,
      "lightTransmittance": 77,
      "gValue": 60,
      "glazingCount": 3,
      "region": [0, -10, -20, -44],
      "img": "assets/images/typen/Triple.svg",
      "cavities": [14, 14]
    };
  }

  getDefaultFrame() {
    return {
      "id": 17,
      "type": "FRAME_TYPE_PVC",
      "uf": 1.3,
      "visibleWidth": 0.11,
      "name": "PVC",
      "img": "assets/images/frame/pvc.svg",
      "ufValues": [1.3, 1.3, 1.3, 1.3, 1.3, 1.3, 1.3],
      "wValues": [0.11, 0.11, 0.11, 0.11, 0.11, 0.11, 0.11]
    };
  }

  private getWindow2DefaultFrame() {
    return {
      "id": 4,
      "type": "FRAME_TYPE_PVC",
      "uf": 1.0,
      "visibleWidth": 0.13,
      "name": "PVC",
      "img": "assets/images/frame/pvc.svg",
      "ufValues": [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0],
      "wValues": [0.13, 0.13, 0.13, 0.13, 0.13, 0.13, 0.13]
    };
  }

  private getWindow2DefaultGlass() {
    return {
      "id": "2",
      "name": "CLIMATOP ECLAZ",
      "type": "Energiegewinnung",
      "structure": "4/16a/4",
      "interiorGlassThickness": 4,
      "exteriorGlassThickness": 4,
      "cavity": "16a",
      "thickness": 24,
      "ug": 1.0,
      "lightTransmittance": 81,
      "gValue": 65,
      "glazingCount": 2,
      "region": [0, -10, -20, -44],
      "img": "assets/images/typen/Double.svg",
      "cavities": [16]
    };
  }
  calcUw(): number {
    //   const res = this.getProject();
    //   const proj = res ? JSON.parse(res) : null;
    //   const windowFrame = proj.windowframe;
    //   const windowGlass = proj?.windowglas;
    //   const windowMuntin = proj?.muntin;

    //   const uf = this.ufArea(this.calcFrameArea(), windowFrame.uf);
    //   const ug = this.ugArea(this.calcGlassArea(), windowGlass.ug);
    //   const psi = this.psiEdge(this.calcDependingPsi(proj), this.calcGlassEdge());
    //   const muntin = this.psiMuntin(windowMuntin.psi, this.calcMuntinLength());
    //   const dUw = this.calcDeltaUw();

    //   const result = ((uf + ug + psi + muntin) / this.calcArea()) + dUw;

    //   proj.data("uw", CaluwinDefault.Helpers.uwUnroundedToString(result));

    //   return result;
    return 0;
  }

  // ufArea = function (af, uf) {
  //   var result = af * uf;
  //   return result;
  // };

}